"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadResultSelectorComponent = DownloadResultSelectorComponent;
const React = __importStar(require("react"));
const PopupComponent = __importStar(require("@genesys/client-core/lib/popup-component"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const ScreenAmountProfile = __importStar(require("@genesys/client-core/lib/screen-amount-profile"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const field_groups_1 = require("../../field-groups");
const ResultTable = __importStar(require("../result-table"));
function updateItems(items, itemKey) {
    return Object.assign(Object.assign({}, items), { [itemKey]: !items[itemKey] });
}
function DownloadResultSelectorComponent({ left, items, onClose, onItemsChange, results, top }) {
    return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({ getPropertyFormats }) => {
        const properties = results.length > 0 ? results[0].result : undefined;
        // The sheet is the same table the screen shows: a row of names, a row of units,
        // then a row per calculated case.
        const rows = properties
            ? ResultTable.toRows(ResultTable.columns(Object.keys(items)
                .filter(key => items[key])
                .map(propertyName => ({ propertyName })), results, getPropertyFormats(field_groups_1.FieldGroup.results, properties), translate), results, getPropertyFormats(field_groups_1.FieldGroup.results, properties))
            : [];
        return (React.createElement(PopupComponent.Component, { onClose: onClose, left: left, top: top },
            React.createElement("ul", null, Object.keys(items).map(key => (React.createElement("li", { key: key },
                React.createElement("label", null,
                    React.createElement("input", { type: "checkbox", id: "checkbox_id", checked: items[key], onChange: () => {
                            const updatedItems = updateItems(items, key);
                            onItemsChange(updatedItems);
                        } }),
                    ResultTable.columnLabel(key, translate)))))),
            React.createElement(Exporter.XlsxSingleSheetExport, { data: rows, filename: "results" }, onClick => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download")))));
    }))));
}
//# sourceMappingURL=download-result-selector.js.map